module.exports = __webpack_public_path__ + "img/printer.6e370720.svg";